module.exports = __webpack_public_path__ + "img/banner_icon_3.c6f05f53.png";